import { faStore, faUser } from '@fortawesome/pro-regular-svg-icons';
import type {
  MonitorDeliveryDetailClient,
  MonitorDeliveryDetailPlace,
} from '../../../../types';
import { formatMonitorAddress } from '../../../../utils';
import { LocationCard } from './components/location-card/location-card';
import styles from './place-customer-cards.module.scss';

interface PlaceCustomerCardsProps {
  place: MonitorDeliveryDetailPlace;
  client: MonitorDeliveryDetailClient;
}

export function PlaceCustomerCards({ place, client }: PlaceCustomerCardsProps) {
  return (
    <div className={styles.cards}>
      <LocationCard
        icon={faStore}
        label="Loja"
        name={place.name}
        address={formatMonitorAddress(place.address)}
        addressTone="secondary"
        href={`/estabelecimentos/${place.id}`}
      />
      <LocationCard
        icon={faUser}
        label="Cliente"
        name={client.name}
        address={formatMonitorAddress(client.address)}
        addressTone="supporting"
      />
    </div>
  );
}
